module.exports = {"id":"dp2_2l3q6","text":"Sharing Through Digital Technologies","instructions":"Which action supports responsible sharing when AI systems are involved?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.2","questionType":"PickOne","random":true,"options":[{"id":"dp2_2l3q6-a1","text":"Reviewing AI-generated content before sharing","score":3.7},{"id":"dp2_2l3q6-a2","text":"Assuming AI outputs are always accurate","score":1.3},{"id":"dp2_2l3q6-a3","text":"Sharing AI content without context","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l3q6.json
// module id = 1021
// module chunks = 41